module.exports = __webpack_public_path__ + "static/media/LambdaBadge.0ce0d957.png";